import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LightShowService, LightShowListView, LightShowFormData } from '../_services/light-show.service';
import { DialogService } from '../_services/dialog.service';
import { ManagementComponentBase } from '../_shared/base.management.component';
import { getUrl } from '../_shared/utils';

import { HttpClient, HttpRequest, HttpResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { UserService } from '../_services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { JWTTokenService } from '../_services/jwtToken.service';
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import { ClipboardService } from 'ngx-clipboard';
import { Environment } from '../..//environments/environment';

@Component({
  templateUrl: './light-show-management.component.html',
  styleUrls: ['./light-show-management.component.css'],
  encapsulation: ViewEncapsulation.None
})


export class LightShowManagementComponent extends ManagementComponentBase<LightShowListView, LightShowFormData> {

  private clipboardService: ClipboardService;

  constructor(
    public service: LightShowService,
    router: Router,
    dialogService: DialogService,
    viewRef: ViewContainerRef,
    httpClient: HttpClient,
    userService: UserService,
    spinner: NgxSpinnerService,
    jwtTokenService: JWTTokenService,
    clipboardService: ClipboardService) {

    super(service, router, dialogService, viewRef, httpClient, userService, spinner, jwtTokenService);
    this.clipboardService = clipboardService;
  }

  public downloadStates = {};
  public copied = {};

  protected GetRouteName(): string {
    return 'light-show';
  }

  handleEditLightShow (id: number, serviceId: number) {

    this.loading = true;

    this.service.getIsOpen(id)
      .subscribe(data => {

        this.loading = false;

        if (data?.currentlyWorking) {

          const modalTitle = `${this.hasSiteManagement ? data.currentlyWorking : 'Someone'} is currently working on this Light Show.`;

          this.dialogService.confirm(modalTitle, 'Are you sure you want to edit it?', this.viewRef)
            .then((res) => {

              if (res){

                this.edit(id, serviceId);
              }
            });

        } else {

          this.edit(id, serviceId);
        }
      })
  }

  duplicate(id: number) {
    this.loading = true;
    this.dialogService.confirm('Are you sure?', 'This will duplicate the lightshow.', this.viewRef)
      .then((res) => {
        if (res){
          this.spinner.show();
          this.service.copy(id).subscribe(copiedLightShow => {
            this.spinner.hide();
            this.items.unshift(copiedLightShow);
            this.displayItems.unshift(copiedLightShow);
            this.showInactive = false;
            this.displayItems = this.items.filter(i => i.active);
          });
        }
        this.loading = false;
      });
  }

  // TODO: This needs to be cleaned up, I'm sure there is a better way
  // A good start would be to remove all references to http, and replace it with httpClient
  public checkDownloadLink(lightShow: LightShowListView, rowIndex: number, triggerFile: boolean = false) {

    if (triggerFile) {

      this.downloadStates[rowIndex + '-download-triggers'] = 1;
      this.downloadStates[rowIndex + '-downloadPercent-triggers'] = 0;

    } else {

      this.downloadStates[rowIndex + '-download'] = 1;
      this.downloadStates[rowIndex + '-downloadPercent'] = 0;
    }

    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Authorization': 'Bearer ' + this.jwtTokenService.getToken('portal')
    });

    const apiRoute = triggerFile ? getUrl(`${this.GetRouteName()}/download/${lightShow.id}/triggers`) : getUrl(`${this.GetRouteName()}/download/${lightShow.id}`);

    this.httpClient.get(apiRoute, {headers: headers}).subscribe(
      (signedUrls: any) => {
        const headUrl = signedUrls.headUrl;
        const downloadUrl = signedUrls.getUrl;
        const fileName = lightShow.name.split(' ').join('_').toLowerCase() + '-' + signedUrls.fileName;
        const options = { responseType: 'blob' as 'blob' };

        this.httpClient.head(headUrl, options).subscribe(
          (response: any) => {
              if (lightShow.isPendingDesign) {
                this.dialogService.alert(
                  'Light Show Design In Progress',
                  'The file you have selected contains a custom track and \
                    has yet to have its Light Show designed. Please allow 7 business days for us to complete your show. While you will be able to download this file, the Light Show will \
                    not work until we finish. If you need it rushed, please notify your account representative for details',
                  this.viewRef
                );
              }

              const req = new HttpRequest('GET', downloadUrl, {
                reportProgress: true,
                observe: 'events',
                responseType: 'arrayBuffer'
              });

              this._httpClient.request(req).subscribe(event => {
                // Access event stream to report progress
                if (event.type === HttpEventType.DownloadProgress) {
                  // Calculate percentage done from the 'Content-Size'
                  const percentDone = Math.round(100 * event.loaded / event.total);

                  if (triggerFile) {

                    this.downloadStates[rowIndex + '-downloadPercent-triggers'] = percentDone;

                  } else {

                    this.downloadStates[rowIndex + '-downloadPercent'] = percentDone;
                  }

                } else if (event instanceof HttpResponse) {
                  const url = window.URL.createObjectURL(new Blob([event.body as ArrayBuffer], {type: 'application/octet-stream'}));
                  const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
                  a.href = url;
                  a.download = fileName;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);

                  if (triggerFile) {

                    this.downloadStates[rowIndex + '-download-triggers'] = 3;

                  } else {

                    this.downloadStates[rowIndex + '-download'] = 3;
                  }
                }
              });
          },
          err => {
            this.dialogService.alert('Download Pending', 'Your light show will be ready momentarily, please check back in a few minutes. If this message persists, please contact support@connectwithcue.com', this.viewRef);

            if (triggerFile) {

              this.downloadStates[rowIndex + '-download-triggers'] = 0;

            } else {

              this.downloadStates[rowIndex + '-download'] = 0;
            }
          });
      },
      () => {
        this.dialogService.alert('Download Error', 'There appears to be an error with your file, please contact support@connectwithcue.com, sorry about that!', this.viewRef);

        if (triggerFile) {

          this.downloadStates[rowIndex + '-download-triggers'] = 4;

        } else {

          this.downloadStates[rowIndex + '-download'] = 4;
        }
      }
    );
  }

  public copyPublicLink(referenceNumber: string): void {

    const link = Environment.production ? `https://portal.cueaudio.com/preview/${referenceNumber}`
      : `https://portal.dev.cueaudio.com/preview/${referenceNumber}`;

    this.copied[referenceNumber] = true;

    this.clipboardService.copyFromContent(link);
  }
}
